import React from 'react';
import { Table, Tag, Empty } from 'antd';

/**
 * 已绑定物模型 — 只读反显（对齐 Real 项目 BoundAlgorithmList.vue）
 * @param {string} aiiotTypeConfig - JSON 字符串，如 '[{"AlgorithmType":1010,"AIIoTName":"云端录像","Config":{}}]'
 */
const BoundAlgorithmList = ({ aiiotTypeConfig }) => {
    let list = [];
    if (aiiotTypeConfig) {
        try {
            const parsed = JSON.parse(aiiotTypeConfig);
            list = Array.isArray(parsed) ? parsed : [];
        } catch {
            list = [];
        }
    }

    if (list.length === 0) {
        return (
            <div style={{ minHeight: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Empty description="暂无绑定，请前往算法库绑定后自动关联" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        );
    }

    const columns = [
        {
            title: '算法ID (AIIoTType)',
            dataIndex: 'AlgorithmType',
            width: 150,
            align: 'center',
            render: (t) => <Tag>{t}</Tag>,
        },
        {
            title: '算法名称',
            dataIndex: 'AIIoTName',
        },
    ];

    return (
        <div style={{ minHeight: 60 }}>
            <Table
                dataSource={list}
                columns={columns}
                rowKey="AlgorithmType"
                size="small"
                bordered
                pagination={false}
            />
        </div>
    );
};

export default BoundAlgorithmList;
